var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-menu",
    {
      attrs: {
        bottom: "",
        left: "",
        "offset-y": "",
        "min-width": "220"
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function fn(_ref) {
            var on = _ref.on,
              attrs = _ref.attrs
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        icon: "",
                        small: "",
                        "aria-label": "Actions for ".concat(_vm.mailbox.email)
                      },
                      nativeOn: {
                        click: function click($event) {
                          $event.stopPropagation()
                        }
                      }
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        small: ""
                      }
                    },
                    [_vm._v("mdi-dots-vertical")]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "v-list",
        {
          staticClass: "py-1",
          attrs: {
            dense: ""
          }
        },
        [
          _vm._l(_vm.items, function(item) {
            return _c(
              "v-list-item",
              {
                key: item.action,
                staticStyle: {
                  "min-height": "40px"
                },
                on: {
                  click: function click($event) {
                    return _vm.emit(item.action)
                  }
                }
              },
              [
                _c(
                  "v-list-item-icon",
                  {
                    staticClass: "mr-3 my-2"
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          small: "",
                          "aria-hidden": "true"
                        }
                      },
                      [_vm._v(_vm._s(item.icon))]
                    )
                  ],
                  1
                ),
                _c("v-list-item-title", [_vm._v(_vm._s(item.title))])
              ],
              1
            )
          }),
          _c("v-divider", {
            staticClass: "my-1"
          }),
          _c(
            "v-list-item",
            {
              staticStyle: {
                "min-height": "40px"
              },
              on: {
                click: function click($event) {
                  return _vm.emit("delete")
                }
              }
            },
            [
              _c(
                "v-list-item-icon",
                {
                  staticClass: "mr-3 my-2"
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        small: "",
                        color: "red",
                        "aria-hidden": "true"
                      }
                    },
                    [_vm._v("mdi-trash-can-outline")]
                  )
                ],
                1
              ),
              _c(
                "v-list-item-title",
                {
                  staticClass: "red--text"
                },
                [_vm._v("Delete")]
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }